import { addErrors, clearCursorWait, clearErrors, removeItem, setCursorWait, setItem, writeMessage } from '../helpers/base';
import { KeydownListener } from '../helpers/keydown_listener';

let turnstileToken = null;
let isTurnstileComplete = false;

// Render Turnstile
window.turnstileCallback = function(token) {
	turnstileToken = token;
	isTurnstileComplete = true;
};

window.turnstileError = function(err) {
	turnstileToken = null;
	isTurnstileComplete = false;

	writeMessage(messageElement, 'Turnstile verification failed. Please try again.', 'error');
};

const formElement = document.getElementById('form_login');
const messageElement = document.getElementById('message');

function initEventListeners() {
	const emailInput = document.getElementById('email');
	const passwordInput = document.getElementById('password');

	// Check if the email input value is not empty
	if (emailInput.value !== '') {
		// Focus on the password input if email is not empty
		passwordInput.focus();
	} else {
		// Focus on the email input if it's empty
		emailInput.focus();
	}

	const btnLogin = document.getElementById('btn_login');

	if (!btnLogin) {
		console.error('Element btn_login does not exist.');
		return;
	}

	btnLogin.addEventListener('click', (e) => {
		e.preventDefault();

		submitForm();
	});
}

function initSection() {
	const rememberMe = localStorage.getItem('remember_me');

	if (rememberMe === 'true') {
		document.querySelector('#remember_me').checked = true;

		const email = localStorage.getItem('email');

		if (typeof email === 'string' && email !== null) {
			document.querySelector('#email').value = email;
		}
	}
}

function setKeyPress() {
	const keyListener = new KeydownListener();

	// Adds listener.
	keyListener.toggle(submitForm);
}

async function submitForm() {
	// Get form elements
	const emailInput = document.getElementById('email');
	const passwordInput = document.getElementById('password');

	// Basic client-side validation
	const email = emailInput?.value?.trim() || '';
	const password = passwordInput?.value || '';

	clearErrors(formElement);

	const errors = [];

	if (!email) {
		// errors.push({ field: 'email', message: 'Please enter your email address.' });
		errors.email = 'Please enter your email address.';
	} else {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (!emailRegex.test(email)) {
			errors.email = 'Please enter a valid email address.';
		}
	}

	if (!password) {
		// errors.push({ field: 'password', message: 'Please enter your password.' });
		errors.password = 'Please enter your password.';
		// } else if (password.length < 8) {  // Example additional rule
		// 	errors.password = 'Password must be at least 8 characters long.';
	}

	if (Object.keys(errors).length > 0) {
		// Show field-specific errors
		addErrors(formElement, errors);

		// Optional: show a general message as well
		writeMessage(messageElement, 'Please complete all required fields.', 'error');

		return; // Stop execution
	}

	// Check if Turnstile is complete
	if (!isTurnstileComplete || !turnstileToken) {
		writeMessage(messageElement, 'Please verify that you are human.', 'error');

		return;
	}

	const formData = new FormData(formElement);

	// Add Turnstile token to FormData
	formData.append('cf-turnstile-response', turnstileToken);

	// Convert FormData to a URL-encoded string
	const formBody = new URLSearchParams(formData).toString();

	const rememberMe = document.getElementById('remember_me').checked;
	setItem('remember_me', rememberMe);

	if (rememberMe) {
		setItem('email', email);
	} else {
		removeItem('email');
		removeItem('remember_me');
	}

	try {
		setCursorWait();

		const response = await fetch(`${window.rest_object.url}login`, {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/x-www-form-urlencoded',
				'X-WP-Nonce': window.rest_object.nonce
			},
			body: formBody,
			cache: 'no-cache'
		});

		const result = await response.json();
		const { data, errors: responseErrors, message, status } = result;

		clearErrors(formElement);

		if (status === 'expired') {
			window.location = '/expired';
			return;
		}

		if (responseErrors && typeof responseErrors === 'object') {
			addErrors(formElement, responseErrors);
		}

		if (!response.ok) {
			writeMessage(messageElement, message || 'Login failed.', 'error');
			resetTurnstile();
			return;
		}

		const accessToken = data?.access_token || null;

		if (status === 'success') {
			if (accessToken) {
				const target = new URL('/dashboard', window.location.origin);

				window.location.assign(target.toString());
			} else {
				writeMessage(messageElement, 'Access token (JWT) was not found in result.', 'error');
			}
		} else {
			writeMessage(messageElement, message || 'No account was found with that user/password combination. Please try again.', status || 'error');
			resetTurnstile();
		}
	} catch (error) {
		const { message } = error;

		writeMessage(messageElement, message, 'error');

		resetTurnstile();
	} finally {
		clearCursorWait();
	}
}

// Reset Turnstile on network error
function resetTurnstile() {
	if (!window.turnstile) {
		return;
	}

	turnstile.reset();
	isTurnstileComplete = false;
	turnstileToken = null;
}

document.addEventListener('DOMContentLoaded', function() {
	console.log('DOM loaded...');
	initSection();
	setKeyPress();
	initEventListeners();
});
